import { render, staticRenderFns } from "./address-comment.vue?vue&type=template&id=2cc96f66&scoped=true"
import script from "./address-comment.vue?vue&type=script&lang=js"
export * from "./address-comment.vue?vue&type=script&lang=js"
import style0 from "./address-comment.vue?vue&type=style&index=0&id=2cc96f66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc96f66",
  null
  
)

export default component.exports